export const DataHooks = {
  hsb: 'color-picker-hsb',
  hue: 'color-picker-hue',
  converter: 'color-picker-converter',
  children: 'color-picker-children',
  cancelButton: 'color-picker-cancel-button',
  confirmButton: 'color-picker-confirm-button',
  history: 'color-picker-history',
  historyPrevious: 'color-picker-history-previous',
  historyCurrent: 'color-picker-history-current',
  addColor: 'color-picker-add-color',
};
